import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19.06,13.51a1,1,0,0,0-1.11.87A7,7,0,0,1,11,20.5H5.41l.64-.63a1,1,0,0,0,0-1.41A7,7,0,0,1,9.25,6.72a1,1,0,0,0-.5-1.94A9,9,0,0,0,4,19.12L2.29,20.79a1,1,0,0,0-.21,1.09A1,1,0,0,0,3,22.5h8a9,9,0,0,0,8.93-7.88A1,1,0,0,0,19.06,13.51ZM19,7.5a2,2,0,0,0-1.18.39l-1.75-.8L18,6.21a2,2,0,0,0,1,.29,2,2,0,1,0-2-2l-1.9.87A2,2,0,0,0,14,5a2,2,0,0,0,0,4,2,2,0,0,0,.93-.24l2.09,1A2,2,0,1,0,19,7.5Z" }, null, -1)
  ])))
}
export default { render: render }